<template>
  <div class="attribute-group col-12 product-services rotation" v-if="getShow()">
    <div class="form-group">
      <input
        type="checkbox"
        name="isHorizontal"
        id="rotate"
        @change="toggleCheckbox($event, 'isHorizontal')"
        :checked="product.attributes.isHorizontal"
      />
      <div class="text">
        <label for="rotate">{{ $t("rotate_glass") }}</label>
        <img src="/img/product/rotation.png" alt="Rotácia ikonka" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { rotationCategoryId } from "../../../../config";
import useProduct from "../useProduct";

export default {
  computed: {
    ...mapGetters({
      product: "product/getProduct",
    }),
  },
  methods: {
    getShow() {
      return this.rotationCategoryId.includes(this.product.category_id);
    },
  },
  setup() {
    const { toggleCheckbox } = useProduct();

    return {
      rotationCategoryId,
      toggleCheckbox,
    };
  },
};
</script>
